import React from 'react';
import OrdersTable from 'components/Table/Orders';
import { ordersModelInvoiceSlider } from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';

const InvoiceSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="Notas Fiscais"
        tableSearchClassName=" "
        tabFilter={{ billingDate: { ne: null } }}
        model={ordersModelInvoiceSlider}
        pageSize={5}
        showButton={false}
        showFilter
        showTypeDateFilter
      />
    </Column>
  </>
);

export default InvoiceSlider;
